import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { Button } from './ui/Button';
import { Container } from './ui/Container';
import { ImageCarousel } from './ImageCarousel';
export function HeroSection() {
  return <div className="relative overflow-hidden bg-white pt-16 pb-32 lg:pt-24 lg:pb-40" data-id="element-37">
      <Container data-id="element-38">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-39">
          <div className="sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:text-left" data-id="element-40">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl" data-id="element-41">
              Turn Your Klaviyo Flows Into{' '}
              <span className="gradient-text block" data-id="element-42">Revenue Machines</span>
            </h1>
            <p className="mt-6 text-base text-gray-500 sm:text-lg md:mt-10 md:text-xl" data-id="element-43">
              AI-powered flow optimization that finds hidden opportunities,
              fixes performance issues, and proves ROI—automatically.
            </p>
            <div className="mt-8 sm:mx-auto sm:max-w-lg sm:flex sm:justify-center md:mt-10 lg:mx-0 lg:justify-start" data-id="element-44">
              <div className="rounded-md shadow" data-id="element-45">
                <a href="https://app.useflowsense.com/auth/signup" data-id="element-46">
                  <Button size="lg" className="w-full md:w-auto" rightIcon={<ArrowRight className="h-5 w-5" data-id="element-48" />} data-id="element-47">
                    Signup Free
                  </Button>
                </a>
              </div>
              <div className="mt-3 sm:mt-0 sm:ml-3" data-id="element-49">
                <Button variant="outline" size="lg" className="w-full md:w-auto" leftIcon={<Play className="h-5 w-5" data-id="element-51" />} data-id="element-50">
                  See How It Works
                </Button>
              </div>
            </div>
            <div className="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-center lg:justify-start" data-id="element-52">
              <div className="flex items-center space-x-5" data-id="element-53">
                <div className="flex -space-x-2 overflow-hidden" data-id="element-54">
                  {[1, 2, 3, 4].map(i => <img key={i} className="inline-block h-8 w-8 rounded-full ring-2 ring-white" src={`https://placehold.co/32x32?text=${i}`} alt="" data-id="element-55" />)}
                </div>
                <div className="text-sm font-medium text-gray-500" data-id="element-56">
                  Trusted by{' '}
                  <span className="font-bold text-gray-900" data-id="element-57">500+ brands</span>
                </div>
              </div>
            </div>
          </div>
          <div className="relative mt-12 sm:mx-auto sm:max-w-lg lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:max-w-none lg:items-center" data-id="element-58">
            <ImageCarousel data-id="element-59" />
          </div>
        </div>
      </Container>

      <style data-id="element-60">{`
        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        
        .gradient-text {
          background: linear-gradient(90deg, #6366F1, #8B5CF6, #10B981, #3B82F6, #6366F1);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: gradientShift 8s ease infinite;
        }
      `}</style>
    </div>;
}